import { render, staticRenderFns } from "./products9A-classes-inquiry.vue?vue&type=template&id=a376b4d0&"
import script from "./products9A-classes-inquiry.vue?vue&type=script&lang=js&"
export * from "./products9A-classes-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports